function replaceParamValues(idParam: string) {
    const charactersToReplace = ['=', '/', '+'];
    const shouldReplace = charactersToReplace.some(char => idParam.indexOf(char) >= 0);
    if (shouldReplace) {
        let newIdParam = idParam.replace(/\//g, '%2F');
        newIdParam = newIdParam.replace(/\+/g, '%2B');
        newIdParam = newIdParam.replace(/\=/g, '%3D');
        return newIdParam;
    }
    return idParam;
}

export default replaceParamValues;
